/* RESPONSIBLE TEAM: team-automation-foundations */
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export type FinAgentType = 'support' | 'sales' | 'ecommerce' | 'success';
export type FinAgentSelection = FinAgentType | 'all-roles';

const STORAGE_KEY = 'fin-agent-type-last-on-fin-route';

function readStored(): FinAgentSelection {
  if (typeof sessionStorage === 'undefined') {
    return 'all-roles';
  }
  let stored = sessionStorage.getItem(STORAGE_KEY);
  if (
    stored === 'support' ||
    stored === 'sales' ||
    stored === 'ecommerce' ||
    stored === 'success'
  ) {
    return stored;
  }
  return 'all-roles';
}

function writeStored(value: FinAgentType) {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.setItem(STORAGE_KEY, value);
  }
}

export default class FinAgentTypeService extends Service {
  @tracked currentAgentType: FinAgentSelection = readStored();

  setCurrentAgentType(value: FinAgentType) {
    this.currentAgentType = value;
    writeStored(value);
  }
}
